<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>路由管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'routeList' }"
          >路由列表</el-breadcrumb-item
        >
        <el-breadcrumb-item>路由详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form
        ref="listForm"
        :rules="checkListParams"
        style="width: 800px;"
        :model="listParams"
        label-width="100px"
      >
        <el-form-item label="依属项目：" prop="subject">
          <el-select
            style="width: 80%;"
            size="small"
            v-model="listParams.subject"
          >
            <el-option value="01" label="服务加"></el-option>
            <el-option value="02" label="老干局"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目分支：" prop="branch">
          <el-select
            style="width: 80%;"
            size="small"
            v-model="listParams.branch"
          >
            <el-option
              v-for="item in branchList"
              :value="item.id"
              :label="item.title"
              :key="item.id"
            >
            </el-option>
          </el-select>
          <el-button type="text" class="add-btn">新增项目分支</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button
            class="align-left"
            type="primary"
            size="small"
            @click="toCreate"
          >
            新增
          </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ tableData.length }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column width="60" align="center" label="序号">
          <template slot-scope="scope">
            <span
              v-text="
                (pager.pageIndex > 1
                  ? (pager.pageIndex - 1) * pager.pageSize
                  : 0) +
                  scope.$index +
                  1
              "
            >
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="branch" align="center" label="项目分支">
        </el-table-column>

        <el-table-column
          align="center"
          v-for="(item, index) in columnList"
          :key="item.id"
          :label="item.title"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.routeList[index]">{{
              scope.row.routeList[index]
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope)">
              修改
            </el-button>

            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要删除该条数据？"
              @confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        subject: "01"
      },
      checkListParams: {
        subject: [
          { required: true, message: "请选择依属项目", trigger: "change" }
        ],
        branch: [
          { required: true, message: "请选择项目分支", trigger: "change" }
        ]
      },
      branchList: [],
      pager: {
        pageIndex: 1,
        pageSize: 15
      },
      columnList: [
        { id: 1, title: "一级路由" },
        { id: 2, title: "二级路由" },
        { id: 3, title: "三级路由" }
      ],
      tableData: [
        {
          id: 1,
          branch: "服务加供应局",
          routeList: ["platformManagement", "routeManagement", "routeList"]
        }
      ],
      tableLoading: false
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 新增路由
     */
    toCreate() {},
    /**
     * 编辑条目数据
     * @params row
     */
    editItem(row) {},
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {}
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .hx-form-container {
    .add-btn {
      margin-left: 10px;
      span {
        text-decoration: underline;
      }
    }
  }
}
</style>
